<template>
    <el-dialog class="dialog-order-info" title="余票时间设置" :visible.sync="dialogVisible" @close="cancel" width="35%">
        <el-form class="g-form-grid" ref="form" :model="form" label-width="120px" :rules="rules">

            <el-form-item label="日期 :" prop="times">
                <el-date-picker type="date" placeholder="选择日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd" readonly
                    v-model="nowDate" style="width: 100%;"></el-date-picker>
            </el-form-item>

            <el-form-item label="开始时间 :" prop="startTime">

                <el-time-picker class="w-100" value-format="HH:mm" format="HH:mm" v-model="form.startTime"
                    placeholder="选择日期时间"></el-time-picker>

            </el-form-item>

            <el-form-item label="结束时间 :" prop="endTime">

                <el-time-picker class="w-100" value-format="HH:mm" format="HH:mm" v-model="form.endTime"
                    placeholder="选择日期时间"></el-time-picker>
            </el-form-item>

            <!-- <el-form-item label="状态 :" prop="isopen">
                <el-select v-model="form.isopen" placeholder="请选择启用状态">
                    <el-option v-for="item in openList" :key="item.value" :label="item.label"
                        :value="item.value"></el-option>
                </el-select>
            </el-form-item> -->

            <el-form-item label="开放票数 :" prop="openNum">
                <el-input v-model="form.openNum"></el-input>
            </el-form-item>

        </el-form>

        <div slot="footer" class="footer mt-30">
            <el-button @click="cancel">取消</el-button>
            <el-button @click="submit" type="primary" :loading="loadingSave">确定</el-button>
        </div>
    </el-dialog>
</template>

<script>
export default {
    data() {
        return {
            dialogVisible: false,
            form: {
                startTime: '',
                endTime: '',
                openNum: null
            },
            nowDate: '',
            openList: [{ label: '有票', value: '1' }, { label: '闭馆', value: '2' }, { label: '已满', value: '3' }],
            pageType: '',
            rules: {
                openNum: [
                    { required: true, message: '开放票数不能为空', trigger: 'blur' }
                ],
                startTime: [
                    { required: true, message: '开始预约时间不能为空', trigger: 'blur' }
                ],
                endTime: [
                    { required: true, message: '停止预约时间不能为空', trigger: 'blur' }
                ]
            },
            listQuery: {
                currentPage: 1,
                size: 10
            },
            settingObj: {},
            loadingSave: false,
            chooseRowIds: '' // 当前导出选中藏品id
        }
    },
    methods: {
        init(pageType, obj) {
            this.pageType = pageType
            this.nowDate = this.$route.query.date
            if (obj) {
                this.settingObj = JSON.parse(JSON.stringify(obj))
                this.form = {
                    startTime: this.settingObj.startTime,
                    endTime: this.settingObj.endTime,
                    openNum: this.settingObj.openNum
                }
            }
            this.dialogVisible = true
        },


        cancel() {
            this.$refs['form'].resetFields()
            this.form = {
                startTime: '',
                endTime: '',
                openNum: null
            }
            this.settingObj = {}
            this.dialogVisible = false
        },

        submit() {
            this.$refs['form'].validate(vaild => {
                if (vaild) {
                    let params = {
                        ...this.form,
                        settingTimesId: this.$route.query.ticketId
                    }

                    if (this.pageType == 'edit') {
                        params.id = this.settingObj.id
                    }
                    this.loadingSave = true
                    this.$api.appointSetting.saveSurplusTicket(params).then(res => {
                        this.loadingSave = false
                        if (res.success) {
                            this.$message.success('保存成功')
                            this.$emit('refresh')
                            this.cancel()
                        } else {
                            this.$message.error(res.message || '系统异常')
                        }
                    }).catch(() => {
                        this.loadingSave = false
                    })
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped></style>